import React from 'react';
import DocumentTitle from 'react-document-title';
import CareersInfoPage from '../components/company/careers-info-page';

const CareersInfoRoute = () => (
  <div>
    <DocumentTitle title="Careers Info | NerdWallet" />
    <CareersInfoPage />
  </div>
);

CareersInfoRoute.displayName = 'CareersInfoRoute';
CareersInfoRoute.analyticsName = 'careers_info_page';

export default CareersInfoRoute;
